<template>
	<div id="hero" >
		<div
		class="hero"
		:style="{

			backgroundImage: `url(${require(`@/assets/images/hero/${heroBgSrc}`)})`,
			}"
			>
			<div class="quick_links fixed" :class="{scroll: scrollActive}"  :scroll="handleScroll" >

				<!-- <div class="links">
					<a href="#" target="_blank" @click="store.dispatch('purl/purlTracking', 'Buy Now')">
						<button type="button" class="quick_btn renew_btn">
							Buy Now
						</button>
					</a>
				</div> -->

			</div>
		<div class="hero_content text-center">

			<h1 class=" fw-bold welcome-msg">This is your year!</h1>
			 <hr/>
			 <p class="waiting_msg">YOUR OPPORTUNITY TO PURCHASE CUBS SEASON TICKETS IS COMING IN EARLY 2023!</p>
			<div class="baseball_quotes">
				<p class="quote">“Ultimately, we have to build on that momentum, that's going to be the focus of this offseason … We absolutely want to compete next year and build something really special now for the fans.” </p>
				<p class="author">– Jed Hoyer</p>

			</div>

	   </div>
	   <div class="scroll_section">
		   <div class="scroll_content">
		   		<p>SCROLL DOWN FOR your EXCLUSIVE INFORMATION</p>
				<img :src="require(`@/assets/images/icons/scroll_icon.svg`)" class="scroll_icon" alt="Scroll Icon" />
		   </div>
	   </div>
	</div>
</div>
</template>

<script>
import { reactive, toRefs, computed, watchEffect, onMounted } from "vue";
import { useStore } from "vuex";

export default {
	name: "Hero",
	data() {
		return {
			InvoiceActive: false,
			scrollActive: false,
		// 	slides: [
		// 	{
		//       id: 'slide-1',
		// 	  quote: "We absolutely want to compete next year. We also want to build something really special for the fans.",
		// 	  author: "- Jed Hoyer",
		//     },
		// 	{
		//       id: 'slide-2',
		// 	  quote: "Ultimately, we have to build on that momentum, that's going be the focus of this offseason.",
		// 	  author: "- Jed Hoyer",
		//     },
		// 	{
		//       id: 'slide-3',
		// 	  quote: "We will be active in free agency and have the necessary resources available to substantially supplement our current roster. ",
		// 	  author: "– Tom Ricketts",
		//     },
		// 	{
		//       id: 'slide-4',
		// 	  quote: "Every day, you the fans, show up and give us the best atmosphere in the entire sport. Thank you for your loyalty and dedication! The best is yet to come.",
		// 	  author: "– Ian Happ",
		//     },
		//
		// ],
		}
	},
	created () {
		window.addEventListener('scroll', this.handleScroll);
	},
	setup() {
		const store = useStore();

		// State
		const state = reactive({

			heroBgSrc: computed(() =>
			"bgImage_hero_3.jpg"
		),
	});

	return { ...toRefs(state), store };
},
methods: {
	handleScroll: function (evt, el) {
	  if (window.scrollY > 200) {
		this.scrollActive = true;
	  }
	  else{
		  this.scrollActive = false;
	  }
	  return window.scrollY > 100
  	},

  	dollarFormat(total) {
	  let newTotal = Number(total.replace(/[$,]/g, ""))
		.toFixed(2)
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	  return newTotal;
	},

},
};
</script>
<style lang="scss" scoped>
.hero {
	// background-image: url("~images/hero/bgImage.jpeg");
	background-position: top;
	background-size: cover;
	display: flex;
	flex-direction: column;
	// justify-content: center;
	// align-items: center;
	overflow: hidden;
	height: 100vh;
	&::after {
		content: "";
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 0;
		// opacity: 0.2;
		// background: theme-var($--ch-theme-secondary);
	}
	.video{

	    width: 100%;
		overflow: hidden;
	    height: 100vh;
		position: absolute;
		left:0px;
		right:0;
	    z-index: 0;
	    // display: flex;
	    // flex-direction: column;
	    // flex-wrap: nowrap;
	    // justify-content: center;
		&::after {
	      content: "";
	      width: 100%;
	      height: 100%;
	      position: absolute;
	      left: 0;
	      top: 0;
	      background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.4) 60%, rgba(0, 0, 0, 0.4) 60%);
	    }
	}
	.text-center{
		// text-align:center;
	}


	&_content {
		z-index: 1;
		display:flex;
		flex-direction:column;
		height:100%;
		// justify-content: flex-start;
		align-items: flex-end;
		margin-top:200px ;
		margin-right: 70px;
		gap: 15px;
		filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.2)) drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.3));

		@media (min-width: 999px) and (max-width: 1200px) {
		 margin-top:15px;
		}
		// margin-left:100px;
		// @include media-breakpoint-up(lg) {
		//   max-width: 800px;
		// }
		// @include media-breakpoint-only(md) {
		//   max-width: 90vh;
		// }
		@include media-breakpoint-down(sm) {
			align-items: center;
			margin:200px 10px 0px 10px;
			gap: 2px;
		}
		h1 {
			font-family: 'Verlag Condensed Bold';
			font-style: normal;
			font-weight: 450;
			font-size: 40px;
			line-height: 75%;
			color:white;
			text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
			text-transform: uppercase;
			margin-bottom:15px;
			@include media-breakpoint-down(sm) {
				font-size: 28px;
				line-height: 100%;
				text-align:center;
			}
			@media (min-width: 999px) and (max-width: 1200px) {
				font-size: 32px;
			}
			// &.welcome-msg{
			// 	border-bottom: red;
			// }
		}
		.waiting_msg{
			font-family: 'Verlag Book';
			font-style: normal;
			font-weight: 450;
			font-size: 18px;
			line-height: 24px;
			width: 500px;
			text-align: right;
			color: #FFFFFF;
			@include media-breakpoint-down(sm) {
				width: 300px;
				text-align: center;
			}
			@include media-breakpoint-only(md) {
				width: 450px;
			}
		}
		.baseball_quotes{
			width: 636px;
			@include media-breakpoint-down(sm) {
				width: 100%;
				font-size: 18px;
				padding:0px 10px;
				text-align:center;
			}
			@media (min-width: 999px) and (max-width: 1200px) {
				width: 436px;
				font-size: 18px;
				line-height: 24px;
				font-family: "Verlag LightItalic", "Verleg Book";
				margin-top:10px;
			}
			// position:absolute;
			// bottom:120px;
			// height: 36px;
			margin-top:45px;
			font-family: "Verlag LightItalic";
			font-style: normal;
			font-weight: 450;
			font-size: 25px;
			line-height: 145%;
			text-align: right;
			color: #FFFFFF;

		}

		hr{
			height:4px;
			width:430px;

			color: #CC3433;
			background: #CC3433;
			border-radius: 16px;
			display:flex;
			justify-content: flex-end;
			align-items:flex-end;
			margin: 0px;
			opacity:1;
			@media (min-width: 999px) and (max-width: 1200px) {
				width:340px;
			}
			@include media-breakpoint-down(sm) {
				width:340px;
				margin: 0px;
			}
		}

	}

	.scroll_section{
		display: flex;
		flex-direction: column;
		align-items: center;
		.scroll_content{
			display: flex;
			flex-direction: column;
			align-items: center;
			position:absolute;
			bottom:10px;
			@media (min-width: 999px) and (max-width: 1200px) {
			 bottom:5px;
			}
		}
		p{
			font-family: 'Verlag Condensed Book';
			font-style: normal;
			font-weight: 400;
			font-size: 18px;
			line-height: 22px;
			display: flex;
			align-items: center;
			text-align: center;
			text-transform: uppercase;
			color: #FFFFFF;
			text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
			margin:0px;
			@media (min-width: 999px) and (max-width: 1200px) {
			font-size: 15px;
			margin-bottom:0px;
			}
		}
		.scroll_icon{
			@media (min-width: 999px) and (max-width: 1200px) {
				height:20px;
			}
		}
	}
}

</style>
